import { useEffect } from "react"

function useBodyScroll(enabled) {
  useEffect(() => {
    document.querySelector("html").style.overflowY = enabled ? "auto" : "hidden"
    return () => {
      document.querySelector("html").style.overflowY = "auto"
    }
  }, [enabled])
}

export { useBodyScroll }
